import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ColumnLayoutViewModelType from '@/ViewModels/Controls/ColumnLayoutViewModel';
import LabelType from '@/Controls/Label';

export default class ColumnLayout extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;

    public constructor(private viewModel: ColumnLayoutViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyBindings(this.jQueryControl, {
            controlName: 'columnlayout',

            controlIdent: this.identifier,

            loader: this.viewModel.isBusy,

            columnLayout: {
                parent: self,

                rows: this.viewModel.rows
            },

            classes: this.definePureComputed({
                read: function () {
                    return ['c-columns-' + this.viewModel.columnsPerRow];
                }
            })
        });

        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('ColumnLayout', ColumnLayout, 'RADPresentation.HTMLClient.DefaultViewExtensions');